// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import * as ActiveStorage from "@rails/activestorage"
import { createConsumer } from "@rails/actioncable"
import "./controllers"

ActiveStorage.start()

// ActionCable consumer를 전역에 노출 (UI Planning 등 vanilla JS에서 사용)
window.ActionCableConsumer = createConsumer()
